(() => {
  'use strict';
  document.documentElement.classList.replace('no-js', 'js');
  const opened = new Map();
  let scrollSnapshot = null;
  function lockScroll() {
    if (scrollSnapshot) return;
    scrollSnapshot = {html: document.documentElement.style.overflow, body: document.body.style.overflow, padding: document.body.style.paddingRight};
    const gutter = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    if (gutter > 0) document.body.style.paddingRight = `${parseFloat(getComputedStyle(document.body).paddingRight) + gutter}px`;
  }
  function releaseScroll() {
    if (opened.size || !scrollSnapshot) return;
    document.documentElement.style.overflow = scrollSnapshot.html;
    document.body.style.overflow = scrollSnapshot.body;
    document.body.style.paddingRight = scrollSnapshot.padding;
    scrollSnapshot = null;
  }
  function finishClose(dialog) {
    const entry = opened.get(dialog);
    if (!entry) return;
    opened.delete(dialog);
    releaseScroll();
    if (!opened.size && entry.focus instanceof HTMLElement && entry.focus.isConnected) entry.focus.focus({preventScroll: true});
  }
  function open(dialog) {
    if (!(dialog instanceof HTMLDialogElement) || dialog.open) return;
    const entry = {focus: document.activeElement};
    try {
      dialog.showModal();
      opened.set(dialog, entry);
      lockScroll();
      dialog.dispatchEvent(new CustomEvent('ms:dialog-opened', {bubbles: true}));
    } catch (_) { finishClose(dialog); }
  }
  function close(dialog) {
    if (!(dialog instanceof HTMLDialogElement)) return;
    if (dialog.open) dialog.close();
    finishClose(dialog);
  }
  window.MSDialogs = {open, close};
  document.addEventListener('close', (event) => {
    if (event.target instanceof HTMLDialogElement) finishClose(event.target);
  }, true);
  document.addEventListener('cancel', (event) => {
    const dialog = event.target;
    if (!(dialog instanceof HTMLDialogElement) || event.defaultPrevented) return;
    if (dialog.hasAttribute('data-ms-static-dialog')) {event.preventDefault(); return;}
  }, true);
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const trigger = event.target.closest('[data-ms-dialog-open]');
    if (trigger) {
      const dialog = document.getElementById(trigger.dataset.msDialogOpen);
      if (dialog instanceof HTMLDialogElement) {event.preventDefault(); open(dialog);}
      return;
    }
    const closeTrigger = event.target.closest('[data-ms-dialog-close]');
    if (closeTrigger) {event.preventDefault(); close(closeTrigger.closest('dialog')); return;}
    if (event.target instanceof HTMLDialogElement && !event.target.hasAttribute('data-ms-static-dialog')) {
      const bounds = event.target.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close(event.target);
    }
  });
  document.addEventListener('shopify:section:unload', (event) => {
    for (const dialog of opened.keys()) if (event.target.contains(dialog)) close(dialog);
  });
  let enabled = false;
  let audio = null;
  function updateSound() {
    document.querySelectorAll('[data-ms-sound-toggle]').forEach(button => {
      button.setAttribute('aria-pressed', String(enabled));
      const label = button.querySelector('[data-ms-sound-label]');
      if (label) label.textContent = enabled ? button.dataset.labelOn : button.dataset.labelOff;
      button.querySelectorAll('[data-ms-sound-on]').forEach(icon => {icon.hidden = !enabled;});
      button.querySelectorAll('[data-ms-sound-off]').forEach(icon => {icon.hidden = enabled;});
    });
    document.dispatchEvent(new CustomEvent('ms:soundchange', {detail: {enabled}}));
  }
  function toggle() {
    try {
      if (!audio) {
        const AudioContextClass = window.AudioContext || window.webkitAudioContext;
        if (!AudioContextClass) return false;
        const context = new AudioContextClass();
        const oscillator = context.createOscillator();
        const gain = context.createGain();
        oscillator.type = 'sine'; oscillator.frequency.value = 54; gain.gain.value = 0;
        oscillator.connect(gain).connect(context.destination); oscillator.start();
        audio = {context, oscillator, gain};
      }
      audio.context.resume().catch(() => {enabled = false; updateSound();});
      enabled = !enabled;
      audio.gain.gain.setTargetAtTime(enabled ? 0.018 : 0, audio.context.currentTime, 0.4);
      updateSound();
    } catch (_) {enabled = false; updateSound();}
    return enabled;
  }
  function mechanical() {
    if (!enabled || !audio) return;
    const oscillator = audio.context.createOscillator();
    const gain = audio.context.createGain();
    oscillator.type = 'triangle';
    oscillator.frequency.setValueAtTime(120, audio.context.currentTime);
    oscillator.frequency.exponentialRampToValueAtTime(35, audio.context.currentTime + 1.2);
    gain.gain.setValueAtTime(0.025, audio.context.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, audio.context.currentTime + 1.5);
    oscillator.connect(gain).connect(audio.context.destination); oscillator.start(); oscillator.stop(audio.context.currentTime + 1.5);
    oscillator.onended = () => {oscillator.disconnect(); gain.disconnect();};
  }
  window.MSSound = {get enabled() {return enabled;}, toggle, mechanical};
  document.addEventListener('click', event => {
    if (event.target instanceof Element && event.target.closest('[data-ms-sound-toggle]')) toggle();
  });
  document.addEventListener('shopify:section:load', updateSound);
  document.addEventListener('visibilitychange', () => {
    if (!audio) return;
    if (document.hidden) audio.context.suspend().catch(() => {});
    else if (enabled) audio.context.resume().catch(() => {});
  });
  window.addEventListener('pagehide', () => {if (audio) audio.context.suspend().catch(() => {});});
  function initializeCountries(root = document) {
    root.querySelectorAll('[data-ms-country]').forEach(select => {
      if (!(select instanceof HTMLSelectElement) || select.dataset.msCountryInitialized === 'true') return;
      const initial = select.dataset.default;
      if (initial && Array.from(select.options).some(option => option.value === initial)) select.value = initial;
      select.dataset.msCountryInitialized = 'true';
      select.dispatchEvent(new Event('change', {bubbles: true}));
    });
  }
  initializeCountries();
  document.addEventListener('shopify:section:load', event => initializeCountries(event.target));
})();
